<template>
  <router-view />
</template>

<style>
#app {
  width: 100%;

  background-color: #f5f7fa;
}
</style> 